// @ts-check

/** @file Defines the local Sync queue shell and polymorphic resource association. */

import SyncBase from "../model-bases/sync.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"

/** Durable local mutation row. */
const SyncModel = projectReplicaModel(SyncBase)

export default SyncModel

SyncModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
SyncModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
SyncModel.belongsTo("resource", {polymorphic: true})
